import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Logo from '../../components/login/logo';
import Cover from '../../components/login/cover';

const CheckEmail2fa = ({ t, loginColor, canRegister }) => (
  <section className="Login boxs">
    <div className={`loginleftw ${loginColor}`}>
      <div className="leftinner tc">
        <div className="loginformwidth">
          <div className="loginbox boxs">
            <Logo />
            <div className="loginform boxs">
              <form>
                <div className="loginbtnouter boxs" style={{ color: 'white', fontSize: '24px' }}>
                  {t('Please check your inbox. We\'ve sent you an email with a link to sign in')}
                  <br />
                  <br />
                  <br />
                </div>
                <div className="crtaccfrgtpasbox boxs">
                  <ul>
                    <li>
                      <Link to="/login">{t('Login')}</Link>
                    </li>
                    {canRegister && (
                      <li>
                        <Link to="/register">{t('Create account')}</Link>
                      </li>
                    )}
                  </ul>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Cover />
  </section>
);

CheckEmail2fa.propTypes = {
  t: PropTypes.func.isRequired,
  loginColor: PropTypes.string,
};

export default CheckEmail2fa;



// WEBPACK FOOTER //
// ./src/views/checkEmail2fa/CheckEmail2fa.jsx